import { render } from "./ApiMessages.vue?vue&type=template&id=de1a0bcc&scoped=true&ts=true"
import script from "./ApiMessages.vue?vue&type=script&lang=ts"
export * from "./ApiMessages.vue?vue&type=script&lang=ts"

import "./ApiMessages.vue?vue&type=style&index=0&id=de1a0bcc&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de1a0bcc"]])

export default __exports__